import type { Service } from "../types/booking";

export const services: Service[] = [
  {
    id: "bilan",
    name: "Bilan kinésithérapique",
    category: "prescription",
    duration: 45,
    price: "Remboursé sur ordonnance",
    description:
      "Première séance : évaluation complète, objectifs et plan de rééducation personnalisé.",
    requiresPrescription: true,
  },
  {
    id: "reeducation",
    name: "Séance de rééducation",
    category: "prescription",
    duration: 30,
    price: "Remboursé sur ordonnance",
    description:
      "Rééducation orthopédique, rhumatologique ou post-opératoire, suivie séance après séance.",
    requiresPrescription: true,
  },
  {
    id: "ondes-de-choc",
    name: "Ondes de choc focales",
    category: "prescription",
    duration: 20,
    price: "Supplément 30 €",
    description:
      "Tendinopathies, épine calcanéenne, calcifications : une technologie ciblée pour les douleurs chroniques.",
    requiresPrescription: true,
  },
  {
    id: "hydrojet",
    name: "Hydrojet",
    category: "wellness",
    duration: 20,
    price: "25 €",
    description:
      "Massage par jets d'eau chaude, sans contact ni déshabillage. Détente musculaire et récupération.",
    requiresPrescription: false,
  },
  {
    id: "stendo",
    name: "Soin Stendo",
    category: "wellness",
    duration: 30,
    price: "45 €",
    description:
      "Pulsations rythmées, synchronisées au cœur, pour relancer la circulation et alléger les jambes lourdes.",
    requiresPrescription: false,
  },
];

export const otherDisciplines = ["Ostéopathie", "Orthophonie", "Psychomotricité"];
